export default "__VITE_ASSET__CaVsvwYB__"